/**
 * This function will return true if less the browser is less than or equal to ie9
 * @returns {bool}
 */

export default  {
  lessThanOrEqualIe9: (function () {
    return document.all && !window.atob;
  })()
};




// WEBPACK FOOTER //
// ./frontend/react/sim/core/utils/browserCheck.js